import { Component, EventEmitter, inject, Input, Output, SimpleChanges } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Alert } from 'src/app/shared/models/Alert';
import { AlertService } from 'src/app/shared/services/alert.service';
import { ValidatePermissionsService } from 'src/app/shared/services/validate-permissions.service';
import { FormControl, FormGroup, Validators, FormsModule } from '@angular/forms';
import { emailValidator } from 'src/app/validators/email.validator';
import { InventoryService } from 'src/app/services/inventory.service';
import { RatePlanDTO } from 'src/app/models/RatePlanDTO.model';
import { MasterdataRequestDTO } from 'src/app/models/MasterdataRequestDTO.model';
import { MasterDataDTO } from 'src/app/models/MasterDataDTO.model';
import { DeviceDTO } from 'src/app/models/DeviceDTO.model';
import { StatusSimDTO } from 'src/app/models/StatusSimDTO.model';
import { CarrierDTO } from 'src/app/models/CarrierDTO.model';
import { carrierConstants } from 'src/app/shared/constants/carrierConstants';
import { CustomerPlanSummaryDTO } from 'src/app/models/CustomerPlanSummaryDTO.model';
import { ResponseBase } from 'src/app/models/ResponseBase';
import { CommonModule } from '@angular/common';
declare var bootstrap: any;

@Component({
    selector: 'app-device-form',
    templateUrl: './device-form.component.html',
    styleUrl: './device-form.component.css',
    imports: [CommonModule, FormsModule]
})
export class DeviceFormComponent {
  @Input() userPlans: CustomerPlanSummaryDTO[] = []
  /*
  @Input() isAdmin: boolean = false;
  @Input() isCustomer: boolean = false;
  @Input() isPartner: boolean = false;
  */
  @Input() isEditing: boolean = false;
  @Input() iccid?: string = '';
  @Input() isExternalDialog?: boolean = false;
  @Output() handleCreateUpdateResponse = new EventEmitter<string>();
  @Output() simCreated = new EventEmitter<string>();
  @Input() disableSave?: boolean;

  public permissionsService = inject(ValidatePermissionsService);
  public inventoryService = inject(InventoryService);
  private route = inject(ActivatedRoute);
  private alertService = inject(AlertService);

  simData: DeviceDTO = {} as DeviceDTO;


  form = new FormGroup({
    email: new FormControl('', [Validators.required, emailValidator()]),
  });

  masterdataReqAssigned: MasterdataRequestDTO = {
    nameMaster: 'INVENTORY_ASSIGNED',
  };

  public get isAdmin(): boolean { return this.permissionsService.isAdmin; }
  public get isCustomer(): boolean { return this.permissionsService.isAdmin; }
  public get isPartner(): boolean { return this.permissionsService.isAdmin; }

  public get carrierConstants() {
    return carrierConstants;
  }

  get emailModel() {
    return this.form.get('email');
  }

  selectedFile: File | null = null;
  fileError: boolean = false;
  fieldImportCompleted: boolean = false;

  //iccid?: string = '';
  imei?: string = '';
  firstName?: string = '';
  lastName?: string = '';
  costCenter?: string = '';
  information: string = 'Update SIM / ICCID: ';
  errorMessage?: string = '';
  fieldsCompleted: boolean = false;
  ratePlans: RatePlanDTO[] = {} as RatePlanDTO[];
  carriers: CarrierDTO[] = [] as CarrierDTO[];
  statusSims: StatusSimDTO[] = [];
  newSim: DeviceDTO = {} as DeviceDTO;
  selectedRatePlanId?: number = undefined;
  carrierSelected: string = '';
  assignedSelected?: string = '';
  selectedStatus?: number = undefined;
  listStatusSim: StatusSimDTO[] = [];
  listAssignedTo: MasterDataDTO[] = [];
  filteredRatePlans: RatePlanDTO[] = [];
  isZipCodeEnabled: boolean = false;
  zipCode: string = '';
  originatedFrom: string = '';


  //new fields for user
  modemType?: string = '';
  serialNumber?: string = '';
  mdn?: string = '';
  custom1?: string = '';
  custom2?: string = '';
  ip?: string = '';
  deviceName?: string = '';
  deviceName2?: string = '';
  activationDate?: Date = undefined;
  linkworxActivationDate?: string = undefined;
  carrierActivationDate?: Date = undefined;
  deactivationDate?: string = '';
  suspensionDate?: string = '';
  isPrimaryDevice?: boolean = false;

  selectedUserPlanId?: number = undefined;

         
  devceID: number = 0;

  alert: Alert = {} as Alert;

  isStatusActive: boolean = false;

  isProcessingTheCallback: boolean = false;

  ngOnChanges(changes: SimpleChanges) {

    if (this.isEditing) {

      if (this.iccid) {
        this.inventoryService.getDeviceByIccid(this.iccid).subscribe(
          (response: DeviceDTO) => {
            this.simData = response;
            this.loadData();
          }
        );
      }

    }
  }

  ngOnInit() {

    if (!this.isExternalDialog) {
      this.route.params.subscribe(params => {
        this.devceID = params['id']; // Access the 'id' parameter from the URL
        if (this.devceID) {
          this.isEditing = true
        }
      });
    }

    this.permissionsService.validateAccessLevels(MODULE_ID.Inventory);

    if (this.isEditing) {

      //this.simData = history.state.simData;
      if (this.iccid) {
        this.information = this.information + this.iccid;

        this.inventoryService.getDeviceByIccid(this.iccid).subscribe(
          (response: DeviceDTO) => {
            this.simData = response;
            this.loadData();
          }
        );

      }

    }


    this.inventoryService.getCarriers().subscribe(
      ({ StatusCode, Message, Data }) =>
        Data != null
          ? this.handleGetCarriers(Data)
          : this.handleUnexpectedError(),
      (error) => {
        this.legacyClearFields();
      }
    );



    this.inventoryService
      .getMastersByName(this.masterdataReqAssigned)
      .subscribe(
        ({ StatusCode, Message, Data }) =>
          Data != null
            ? this.handleGetMastersByName(Data)
            : this.handleUnexpectedError(),
        (error) => {
          this.legacyClearFields();
        }
      );
  }

  handleGetCarriers(data: CarrierDTO[]) {
    this.carriers = data;

    this.carrierSelected = this.simData.carrierId?.toString() ?? '';

    this.inventoryService.getStatusSims().subscribe(
      ({ StatusCode, Message, Data }) =>
        Data != null
          ? this.handleGetMastersById(Data)
          : this.handleUnexpectedError(),
      (error) => {
        this.legacyClearFields();
      }
    );

    this.inventoryService.getRatePlans().subscribe(
      ({ StatusCode, Message, Data }) =>
        Data != null
          ? this.handleGetAllRatePlansSuccess(Data)
          : this.handleUnexpectedError(),
      (error) => {
        this.alert = {
          alertMessage: 'Unexpected error. Please try again later.',
          alertType: 'alert alert-danger',
          alertCenter: false,
          alerTitle: '',
          duration: 3000,
        };
        this.alertService.updateAlertState(this.alert);
        this.legacyClearFields();
      }
    );

  }

  loadData() {
    this.iccid = this.simData.iccid;
    this.assignedSelected = this.simData.idAssignedTo ?? '';
    this.imei = this.simData.imei;
    this.firstName = this.simData.firstName;
    this.lastName = this.simData.lastName;
    this.costCenter = this.simData.costCode;
    this.zipCode = this.simData.zipCode ?? '';
    this.originatedFrom = this.simData.originatedFrom ?? '';         

    
    //this.linkworxActivationDate = this.simData.linkworxActivationDate?.split('T')[0];
    this.linkworxActivationDate = this.simData.linkworxActivationDate ? new Date(this.simData.linkworxActivationDate).toLocaleDateString('en-CA') : undefined;
    this.carrierActivationDate = this.simData.carrierActivationDate;

    //this.suspensionDate = this.simData.suspensionDate?.split('T')[0];
    this.suspensionDate = this.simData.suspensionDate ? new Date(this.simData.suspensionDate).toLocaleDateString('en-CA') : undefined;

    //this.deactivationDate = this.simData.deactivationDate?.split('T')[0];
    this.deactivationDate = this.simData.deactivationDate ? new Date(this.simData.deactivationDate).toLocaleDateString('en-CA') : undefined;


    this.modemType = this.simData.modemType;
    this.serialNumber = this.simData.serialNumber;
    this.mdn = this.simData.mdn;


    this.custom1 = this.simData.custom1;
    this.custom2 = this.simData.custom2;
    this.ip = this.simData.ipAddress;
    this.deviceName = this.simData.deviceName;
    this.deviceName2 = this.simData.deviceName2;
    this.activationDate = this.simData.activationDate;
    this.isPrimaryDevice = this.simData.primaryDevice;
    this.selectedRatePlanId = this.simData.ratePlanId;
    this.selectedStatus = this.simData.deviceStatus;

    var carrier = this.carriers.find(a => a.aCarrierName == this.simData.carrierId);
    this.userPlans = this.userPlans.filter(plan => plan.carriers?.some(id => id === Number(carrier?.aCarrierId)));


    if (this.iccid?.startsWith('8901')) {
      var a = this.carriers.find(a => a.aCarrierName == this.carrierConstants['at&t'])
      this.carrierSelected = a?.aCarrierId?.toString() ?? "";
    }
    else if (this.iccid?.startsWith('8914')) {
      var a = this.carriers.find(a => a.aCarrierName == this.carrierConstants.vzw)
      this.carrierSelected = a?.aCarrierId?.toString() ?? "";
    }
    else if (this.iccid?.startsWith('8985')) {
      var a = this.carriers.find(a => a.aCarrierName == this.carrierConstants.msim)
      this.carrierSelected = a?.aCarrierId?.toString() ?? "";
    }

    this.filterRatePlans();
    this.filterStatusSims();

  }

  checkFieldIccid() {



    if (this.iccid?.startsWith('8901')) {
      var a = this.carriers.find(a => a.aCarrierName == this.carrierConstants['at&t'])
      this.carrierSelected = a?.aCarrierId?.toString() ?? "";
    }
    else if (this.iccid?.startsWith('8914')) {
      var a = this.carriers.find(a => a.aCarrierName == this.carrierConstants.vzw)
      this.carrierSelected = a?.aCarrierId?.toString() ?? "";
    }
    else if (this.iccid?.startsWith('8985')) {
      var a = this.carriers.find(a => a.aCarrierName == this.carrierConstants.msim)
      this.carrierSelected = a?.aCarrierId?.toString() ?? "";
    }
    else {
      this.carrierSelected = "";
    }


    this.filterRatePlans();
    this.validateFields();
  }

  toNumber(value?: string) {
    return Number(value);
  }

  handleGetMastersById(data: StatusSimDTO[]) {


    this.statusSims = [];
    this.statusSims = data;
    this.filterStatusSims();

    this.selectedStatus = this.simData.deviceStatus;
    this.loadData();
    this.validateFields();
  }

  handleGetMastersByName(data: MasterDataDTO[]) {
    this.listAssignedTo = data;
  }

  // goBack() {
  //   window.location.href = '/inventory';
  // }

  updateSim(confirmation: boolean) {

    if (confirmation) {
      this.newSim.deviceId = this.simData.deviceId;
      this.newSim.iccid = this.iccid?.trim();
      this.newSim.ratePlanId = this.selectedRatePlanId;
      this.newSim.imei = this.imei;
      this.newSim.firstName = this.firstName;
      this.newSim.lastName = this.lastName;
      this.newSim.costCode = this.costCenter;
      this.newSim.deviceStatus = Number(this.selectedStatus);
      this.newSim.idAssignedTo = this.assignedSelected;
      this.newSim.carrierId = this.getCarrierNameById(this.carrierSelected);
      this.newSim.zipCode = this.zipCode;
      this.newSim.originatedFrom = this.originatedFrom;
      this.newSim.linkworxActivationDate = this.linkworxActivationDate;

      this.newSim.carrierActivationDate = this.carrierActivationDate ? this.carrierActivationDate : undefined;
      this.newSim.deactivationDate = this.deactivationDate ? this.deactivationDate : undefined;
      this.newSim.suspensionDate = this.suspensionDate ? this.suspensionDate : undefined;

      // Fix the bug - value was not stored
      this.newSim.serialNumber = this.serialNumber ? this.serialNumber : undefined;

      /* нет необходимости - на бекенде эти поля не используются
      this.newSim.deactivationDate = this.deactivationDate ? this.deactivationDate : undefined;
      this.newSim.suspensionDate = this.suspensionDate ? this.suspensionDate : undefined;
      */


      this.newSim.modemType = this.modemType;
      this.newSim.mdn = this.mdn;


      this.newSim.custom1 = this.custom1;
      this.newSim.custom2 = this.custom2;
      this.newSim.ipAddress = this.ip;
      this.newSim.deviceName = this.deviceName;
      this.newSim.deviceName2 = this.deviceName2;
      this.newSim.activationDate = this.activationDate;
      this.newSim.primaryDevice = this.isPrimaryDevice;
      this.newSim.userPlanId = this.selectedUserPlanId;

      if (this.isEditing) {
        this.inventoryService.updateSim(this.newSim).subscribe(
          (response: ResponseBase) => {

            this.handleCreateUpdateResponse.emit(response.validationErrorMessage as string);

            if (response.hasValidationErrors) {
              this.handleUpdateValidationError(response.validationErrorMessage as string);
            }
            else {
              this.handleSaveSuccess(this.newSim.iccid!, false);
            }
          },
          (error) => {

            if ((error.status === 400 || error.status === 500) && error.error) {
              // Extraemos los valores específicos
              const statusCode = error.error.StatusCode;
              const message = error.error.Message;
              const data = error.error.Data;

              // Usamos los valores en la función de manejo de error
              this.handleError(statusCode, data);
            } else {
              // Manejo de otros errores
              this.handleUnexpectedError();
              this.alertService.updateAlertState(this.alert);
            }
          }
        );
      }
      else {
        this.inventoryService.createSim(this.newSim).subscribe(
          (response: ResponseBase) => {

            this.handleCreateUpdateResponse.emit(response.validationErrorMessage as string);
            if (response.hasValidationErrors) {
              this.handleUpdateValidationError(response.validationErrorMessage as string);
            }
            else {
              this.handleSaveSuccess(this.newSim.iccid!, true);
            }
          },
          (error) => {
            console.log("Error recibido:", error); // Verificar en consola la estructura
            if ((error.status === 400 || error.status === 500) && error.error) {
              // Extraemos los valores específicos
              const statusCode = error.error.StatusCode;
              const message = error.error.Message;
              const data = error.error.Data;

              // Usamos los valores en la función de manejo de error
              this.handleError(statusCode, data);
            } else {
              // Manejo de otros errores
              this.handleUnexpectedError();
              this.alertService.updateAlertState(this.alert);
            }
          }
        );

      }
    }

  }

  clearMessage() {
    this.errorMessage = '';
  }

  handleUpdateValidationError(error: string) {


    this.isProcessingTheCallback = false;
    this.alertService.error(error);


  }

  handleUnexpectedError() {
    this.isProcessingTheCallback = false;
    this.alertService.error('Unexpected error. Please try again later.');


  }

  getCarrierNameById(carrierId: string) {


    if (this.carriers.length > 0) {
      const carrier = this.carriers.find(
        (c) => c.aCarrierId === Number(carrierId)
      );
      return carrier?.aCarrierName ?? ''; // Si es undefined, devuelve ""  
    }
    return '';
  }

  checkFields() {
    this.validateFields();
  }

  checkFieldsCarrier() {
    this.iccid = '';

    this.filterRatePlans();
    this.filterStatusSims();
    this.validateFields();
  }

  validateFields() {


    if (this.isEditing) {
      if (this.isStatusActive) {
        if (this.iccid && this.carrierSelected && this.selectedRatePlanId && this.selectedStatus) {
          const carrierName = this.getCarrierNameById(this.carrierSelected)

          if (carrierName === carrierConstants.vzw) {

            if (this.imei && this.zipCode) {
              // Si el campo Zip Code está habilitado, debe ser obligatorio
              this.fieldsCompleted = true;
            } else {
              this.fieldsCompleted = false;
            }
          }
          else {
            this.fieldsCompleted = true;
          }


        }
        else {
          this.fieldsCompleted = false;
        }
      }
      else {
        this.fieldsCompleted = true;
      }
    }
    else {


      // Para la creación, todos los campos son obligatorios
      if (!this.iccid || !this.carrierSelected || !this.selectedRatePlanId) {
        this.fieldsCompleted = false;


      }
      else {
        this.fieldsCompleted = true;
      }
    }


    this.isStatusActive = this.selectedStatus === 1 ? true : false;





  }

  handleError(status: number, message: string) {
    this.openErrorMesagge(status, message);
  }

  async handleSaveSuccess(iccid: string, isCreatedNew: boolean) {
    if (!this.isExternalDialog) {
      this.alertService.success('Device updated successfully');
    }
    if (isCreatedNew) {
      this.simCreated.emit(iccid);
      this.clearFields();
    }
  }

  handleGetAllRatePlansSuccess(ratePlans: RatePlanDTO[]) {
    this.ratePlans = [];
    this.ratePlans = ratePlans;
    this.filterRatePlans();
    this.selectedRatePlanId = this.simData.ratePlanId;
    this.validateFields();
  }

  clearFields() {
    this.simData = {};
    this.loadData();
  }

  legacyClearFields() { }


  // Método para abrir la segunda modal desde la primera modal
  openConfirmationModalUpdate() {
    this.isProcessingTheCallback = true;

    //bootstrap.Modal.getOrCreateInstance(document.getElementById('activateUnAssignedDeviceModal')).hide();
    if (this.isExternalDialog) {
      this.updateSim(true);
    } else {
      bootstrap.Modal.getOrCreateInstance(document.getElementById('deviceConfirmationUpdateAlert')).show();
    }
  }



  // Método para abrir la segunda modal desde la primera modal
  openErrorMesagge(status: number, message: string) {
    console.log("MODAL ERROR");
    this.errorMessage = message;
    // Abrir el segundo modal (Confirmation Update)
    const secondModalElement = document.getElementById('errorMesaggeModal');
    if (secondModalElement) {
      const secondModal = new bootstrap.Modal(secondModalElement);
      secondModal.show();
    }
  }

  // Método para filtrar Rate Plans según el Carrier seleccionado y habilitar Zip Code
  filterRatePlans() {

    if (this.carrierSelected && this.ratePlans.length > 0) {
      this.filteredRatePlans = this.ratePlans.filter(
        (plan) => plan.idCarrier === Number(this.carrierSelected)
      );
    } else {
      this.filteredRatePlans = [];
    }

    // Limpiar la selección de Rate Plan si no está en la lista filtrada
    if (!this.isEditing &&
      !this.filteredRatePlans.some(
        (plan) => plan.ratePlanId === Number(this.selectedRatePlanId)
      )
    ) {
      this.selectedRatePlanId = undefined;
    }

    // Habilitar el campo Zip Code solo si el Carrier seleccionado es 1
    this.isZipCodeEnabled = this.carrierSelected === '1';

    // Si se deshabilita, limpiar el campo Zip Code
    if (!this.isZipCodeEnabled) {
      this.zipCode = '';
    }
  }

  // Filtra los Status de la SIM según el Carrier seleccionado
  filterStatusSims() {

    if (this.carrierSelected) {
      this.listStatusSim = this.statusSims.filter(
        (status) => status.aCarrierId === Number(this.carrierSelected)
      );
    } else {
      this.listStatusSim = [];
    }

    // Si el Status seleccionado no está en la lista filtrada, limpiar selección
    if (!this.isEditing &&
      !this.listStatusSim.some(
        (status) => status.aValue === this.selectedStatus
      )
    ) {
      this.selectedStatus = undefined;
    }
  }

  shouldShowZipCodeAsterisk(): boolean {
    const carrier = this.getCarrierNameById(this.carrierSelected)

    if (carrier === carrierConstants.vzw) {
      return true
    }

    return false;
  }


 
}
